import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    user: null,
    token: null,
    refreshToken: null,
    refreshTokenExp: 0,
    projects: [],
    projectPermssions: {},
    exp: 0, // Token expiration time in seconds (UTC) from token
    roles: [],
    permissions: [],
    routeMeta: {},
    hasAuthInfo: false,

    activeProjectId: null,
    activeIdentityId: null,

    session: {
      // activeProjectId is reserved, and used in more complex way
      maskTransparency: 0.5,
    }
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    user: (state) => state.user,
    isAdmin: (state) => {
      if (!state.user) return false;
      return !!state.user.isAdmin;
    },
    session: (state) => (key) => (state.session || defaultState().session)[key],

    token: (state) => state.token,
    refreshToken: (state) => state.refreshToken,

    tokenValid: (state) => (offsetSecs = 0) => state.token && (state.exp - offsetSecs > new Date().getTime() / 1000),
    refreshTokenValid: (state) => (offsetSecs = 0) => state.refreshToken && (state.refreshTokenExp - offsetSecs > new Date().getTime() / 1000),

    roles: (state) => state.roles,
    permissions: (state) => state.permissions,

    isLoggedIn: (state) => state.hasAuthInfo && (state.exp > new Date().getTime() / 1000 || (state.refreshToken && state.refreshTokenExp.exp > new Date().getTime() / 1000)),
    // these are all projects (merged with admin)
    projects: (state) => {
      return state.projects.map((p) => {
        p.role = p.project_users_current.length ? p.project_users_current[0].role : 'unknown';
        p.projectPermssions = state.projectPermssions[p.id] || {};
        return p;
      });
      // return [
      // ...state.projects.filter((e) => !state.user.projects.find((su) => su.id === e.id)),
      // ...(state.user ? state.user.projects.map((s) => {
      //   s.role = s.project_users_current.length ? s.project_users_current[0].role : 'unknown';
      //   return s;
      // }) : []),
      // ];
    },
    activeProject: (state, getters) => {
      if (!state.activeProjectId || !state.user) return null;
      return getters.projects.find((s) => s.id === state.activeProjectId);
    },
    activeProjectPermissions: (state, getters) => {
      if (!state.activeProjectId || !state.user) return {};
      return (getters.projects.find((s) => s.id === state.activeProjectId) || { projectPermssions: {} }).projectPermssions || {};
    },

    // Active project identities
    identities: (state, getters) => {
      return !getters.activeProject || !getters.activeProject.identities
        ? [] : getters.activeProject.identities;
    },

    // Active project identies
    identity: (state, getters) => (id) => getters.identities.find((i) => i.id === id),

    activeIdentity: (state, getters) => {
      return (!state.activeProjectId || !state.activeIdentityId) ? null
        : getters.identities.find((i) => i.id === state.activeIdentityId);
    },
    // id: File id
    fileUrl: (state, getters) => (id, setId, type) => {
      let url = '';

      if (type === 'sample' || type === undefined) {
        url = `${window.location.origin}/cdn/project/${state.activeProjectId}/sample_set/${setId}/samples/file/${id}?token=${getters.token}`;
      } else if (type === 'detection') {
        url = `${window.location.origin}/cdn/project/${state.activeProjectId}/detection_set/${setId}/detections/file/${id}?token=${getters.token}`;
      }
      return url;
    },

  },
  mutations,
  actions,
};

export { store, defaultState };
